function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.538.333A6.67 6.67 0 00.87 7a6.67 6.67 0 006.667 6.667A6.67 6.67 0 0014.205 7 6.67 6.67 0 007.538.333zm0 2c1.107 0 2 .894 2 2 0 1.107-.893 2-2 2s-2-.893-2-2c0-1.106.893-2 2-2zm0 9.467a4.8 4.8 0 01-4-2.147c.02-1.326 2.667-2.053 4-2.053 1.327 0 3.98.727 4 2.053a4.8 4.8 0 01-4 2.147z",
  fill: "#00ada7"
});

function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 14"
  }, props), _ref);
}

export default SvgAvatar;